<div class="datatable-page-header">
  <h1 trans>Tracking Pixels</h1>

  <div class="header">
    <datatable-filters pluralName="pixels" [filters]="filters"></datatable-filters>
    <div class="action-buttons">
      <permission-aware-button permission="tracking_pixels.create">
        <button
          mat-raised-button
          color="accent"
          (click)="showCrupdatePixelModal()"
          class="button-with-icon"
        >
          <mat-icon svgIcon="add"></mat-icon>
          <span trans>Add New Pixel</span>
        </button>
      </permission-aware-button>
    </div>
  </div>
</div>

<div class="datatable responsive-table">
  <mat-progress-bar
    class="loading-bar"
    mode="indeterminate"
    color="accent"
    *ngIf="datatable.paginator && datatable.paginator.loading$ | async"
  ></mat-progress-bar>
  <table class="material-table">
    <thead>
      <tr>
        <th table-header-checkbox></th>
        <th table-sort-header trans>Name</th>
        <th *ngIf="showUserColumn()" table-sort-header trans>Owner</th>
        <th table-sort-header trans>Type</th>
        <th trans>Pixel ID</th>
        <th trans>Last Updated</th>
        <th></th>
      </tr>
      <tr *ngIf="datatable.selectedRows$.value.length as selectedCount">
        <th colspan="7">
          <div
            class="bulk-actions-title"
            [transValues]="{count: selectedCount, resource: 'pixel(s)'}"
            trans
          >
            :count :resource selected:
          </div>
          <div class="bulk-actions">
            <permission-aware-button permission="tracking_pixels.delete">
              <button
                type="button"
                mat-raised-button
                color="warn"
                (click)="maybeDeleteSelectedPixels()"
                trans
              >
                Delete
              </button>
            </permission-aware-button>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let pixel of pixels$ | async">
        <td [table-body-checkbox]="pixel.id"></td>
        <td data-label="Name">{{ pixel.name }}</td>
        <td data-label="Owner" *ngIf="showUserColumn()">
          <user-column [user]="pixel.user"></user-column>
        </td>
        <td data-label="Type">{{ pixel.type }}</td>
        <td data-label="Pixel ID">{{ pixel.pixel_id }}</td>
        <td data-label="Last Updated">{{ pixel.updated_at | formattedDate }}</td>
        <td class="edit-column">
          <permission-aware-button
            permission="tracking_pixels.update"
            [userOwnsResource]="currentUser.get('id') === pixel.user_id"
          >
            <button
              mat-icon-button
              (click)="showCrupdatePixelModal(pixel)"
              [matTooltip]="'Edit tracking pixel' | trans"
            >
              <mat-icon svgIcon="edit"></mat-icon>
            </button>
          </permission-aware-button>
          <permission-aware-button permission="tracking_pixels.delete" class="visible-on-mobile">
            <button
              type="button"
              mat-icon-button
              (click)="maybeDeleteSelectedPixels([pixel.id])"
              trans
            >
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </permission-aware-button>
        </td>
      </tr>
    </tbody>
  </table>
  <no-results-message
    svgImage="location-tracking.svg"
    *ngIf="datatable.paginator.noResults$ | async"
  >
    <span primary-text trans>No tracking pixels have been created yet</span>
  </no-results-message>
  <datatable-footer></datatable-footer>
</div>
